import MmxApi from "../api/mmxApi";

export default {
  requestResetPassword: (params, server, dispatch) => {
    const api = new MmxApi(server, null, dispatch);
    var rtValue = api.user.requestResetPassword(params);
    return rtValue;
  },

  setNewPassword: (params, server, dispatch) => {
    const api = new MmxApi(server, null, dispatch);
    return api.user.setNewPassword(params);
  },
};






// WEBPACK FOOTER //
// ./src/services/resetPasswordService.js